import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function manageBillableTaskTimesheet({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ manageBillableTaskTimesheetShow: true });
  setTimeout(() => {
    pageComponent.billableTaskTimesheet.current?.setState({ currentBillableTask: parameter });
    pageComponent.billableTaskTimesheet.current?.getBillableTaskTimesheetList(parameter.key);
    pageComponent.billableTaskTimesheet.current?.getCompanyUserList();
  }, config.setTimeoutMilliSecond);
}

//装载模板
export function loadBillableTaskTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter > 0) {
    httpClient
      .get('Admin/BillableTaskTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Name: data.data.Name, Description: data.data.Description, EstimatedTime: data.data.EstimatedTime, BaseRate: data.data.BaseRate, BillableRate: data.data.BillableRate });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: sectionComponent.child.current });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ addFromTemplateShow: true });
  component.addFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.addFromTemplate.current?.formRef.current?.resetFields();
    component.addFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], BillableTaskTemplatePresetContentList: [] });
    setTimeout(() => {
      component.addFromTemplate.current?.additionalFormRef.current?.child.current?.getBillableTaskTemplateData();
      component.addFromTemplate.current?.getBillableTaskTemplatePresetDataSource();
      console.log(component.addFromTemplate.current?.additionalFormRef.current?.child.current);
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}
